import Box from '@mui/material/Box'
import { Html, useProgress } from '@react-three/drei'
import { color } from '../../utility/constant/color.constant'

export const SuspenseLoader = (): JSX.Element => {
  const { progress } = useProgress()
  return (
    <Box height={100} width={100} bgcolor={color.white} component={'div'}>
      <img
        src={`image/companyLogo.png`}
        alt={'loading screen'}
        className={'loader'}
      />
      <p className={'progress-loader'}>{progress.toFixed(0)} %</p>
    </Box>
  )
}
